module.exports = __webpack_public_path__ + "static/img/the-jungle-book.3bbd60f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid/the-jungle-book.jpg
// module id = f2gR
// module chunks = 0